<template>
  <app-page lean>
    <!-- leichter Titel wie die übrigen Verwaltungsseiten; die Bereiche als verschachtelte Karten wie im Dashboard
         (Kundenwunsch 13.10.2026) -->
    <div class="app-page-pad price-layout">
      <div class="price-layout__row">
        <TariffzoneDataGrid
          class="price-layout__col"
          @onTariffzoneSelected="onTariffzoneSelected"
        ></TariffzoneDataGrid>
        <TariffversionDataGrid
          class="price-layout__col"
          @onTariffversionSelected="onTariffversionSelected"
          :tariffZoneId="selectedTariffZoneId"
          :permission="selectedTariffZonePermission"
        ></TariffversionDataGrid>
      </div>
      <PriceDataGrid
        :tariffVersionId="selectedTariffVersionId"
        :tariffZoneId="selectedTariffZoneId"
        :tariffZoneName="selectedTariffZoneName"
        :permission="selectedTariffZonePermission"
      ></PriceDataGrid>
    </div>
  </app-page>
</template>

<script>
import TariffzoneDataGrid from "@/components/TariffzoneDataGrid";
import TariffversionDataGrid from "@/components/TariffversionDataGrid";
import PriceDataGrid from "@/components/PriceDataGrid";

export default {
  components: {
    TariffzoneDataGrid,
    TariffversionDataGrid,
    PriceDataGrid,
  },
  data() {
    return {
      selectedTariffZoneId: null,
      selectedTariffVersionId: null,
      selectedTariffZoneName: null,
      selectedTariffZonePermission: null,
    };
  },
  methods: {
    onTariffzoneSelected(data) {
      this.selectedTariffZoneId = data.tariff_zone_id;
      this.selectedTariffZoneName = data.name;
      this.selectedTariffZonePermission = data.permission;
    },
    onTariffversionSelected(data) {
      this.selectedTariffVersionId = data.tariff_version_id;
    },
  },
};
</script>

<style scoped>
.price-layout {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}
.price-layout__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--sp-4);
}
.price-layout__col {
  flex: 1 1 360px;
  min-width: 0;
}

/* Kopfstreifen mit Icon-Knöpfen (Spezifikation 4.6.2): Der Titel („Preise · {Tarifzone}“) kürzt sich mit Ellipse,
   damit die Knöpfe bei wenig Breite (Handy) sichtbar bleiben (AppPanel schneidet ab). */
.price-layout ::v-deep .app-panel__title {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Touch: AppPanel richtet den Streifen auf bündige 44-px-Links aus (0 0 0 16). Icon-Knöpfe mit Kante (44) bekommen
   Luft wie bei Maus: 4 oben/unten, 8 rechts; der Streifen wächst dafür über 44 hinaus. */
html.dichte-touch .price-layout ::v-deep .app-panel__strip--action {
  height: auto;
  min-height: var(--h-strip);
  padding: var(--sp-1) var(--sp-2) var(--sp-1) var(--sp-4);
}
@media (max-width: 599.98px) {
  html.dichte-touch .price-layout ::v-deep .app-panel__strip--action {
    padding-left: var(--sp-3);
  }
}
</style>
